export const refreshPage = {
  description:
    "Please refresh page to continue using Skin and Wound Dashboards."
};
